import React from 'react';

type GifViewerProps = {
  gifSrc: string;
  gifFilename: string | undefined;
  mediaLoaded: boolean;
  onLoaded: (e: React.SyntheticEvent<HTMLImageElement, Event>) => void;
  onError: () => void;
};

export function GifViewer({
  gifSrc,
  gifFilename,
  mediaLoaded,
  onLoaded,
  onError,
}: GifViewerProps) {
  let cardSize;
  if (!mediaLoaded) {
    cardSize = {maxWidth: 0, maxHeight: 0};
  }
  const mediaStyles = {
    ...{cursor: 'pointer', overflow: 'hidden'},
    ...cardSize,
    objectFit: 'contain' as const,
    width: '100%',
    height: '100%',
  };
  return (
    <img
      src={gifSrc}
      alt={gifFilename}
      style={mediaStyles}
      onLoad={onLoaded}
      onError={onError}
    />
  );
}
